import { useContext } from 'react'
import Context from './Context'

export default () => {
  const props = useContext(Context)
  return props
}
